import { useState, useEffect } from 'react'
import { MessageSquare, Info } from 'lucide-react'
import { toast } from 'sonner'
import { apiClient } from '@/shared/services/client'
import { ConfigForm } from '../components/ConfigForm'
import { ConnectionStatus } from '../components/ConnectionStatus'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ConfiguracionWhatsApp() {
  const [config, setConfig] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [testResult, setTestResult] = useState<any>(null)
  const [showInfo, setShowInfo] = useState(false)

  useEffect(() => {
    cargarConfiguracion()
  }, [])

  const cargarConfiguracion = async () => {
    try {
      const response = await apiClient.get('/whatsapp/configuracion/completa')
      setConfig(response.data)
    } catch (error) {
      console.error('Error cargando configuración:', error)
      toast.error('Error al cargar la configuración')
    } finally {
      setLoading(false)
    }
  }

  const handleGuardar = async (datos: any) => {
    try {
      const response = await apiClient.post('/whatsapp/configuracion/', datos)
      setConfig(response.data)
      toast.success('Configuración guardada correctamente')
    } catch (error) {
      console.error('Error guardando configuración:', error)
      toast.error('Error al guardar la configuración')
      throw error
    }
  }

  const handleTestConexion = async () => {
    try {
      const response = await apiClient.post('/whatsapp/configuracion/test-conexion')
      setTestResult(response.data)
      if (response.data.success) {
        toast.success('Conexión exitosa con Twilio')
      } else {
        toast.error('Error al conectar con Twilio')
      }
    } catch (error) {
      setTestResult({ success: false, mensaje: 'Error al probar conexión' })
      toast.error('Error al probar la conexión')
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-600"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center">
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <MessageSquare className="h-6 w-6" />
          Configuración de WhatsApp
        </h1>
        <button
          onClick={() => setShowInfo(!showInfo)}
          className="text-muted-foreground hover:text-foreground transition-colors ml-2"
        >
          <Info className="h-5 w-5" />
        </button>
        {showInfo && (
          <span className="text-muted-foreground ml-2 text-sm animate-in slide-in-from-left-2 duration-200">
            Gestiona las credenciales de Twilio para WhatsApp Business
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-white border-b">
              <CardTitle className="text-base">Credenciales de Twilio</CardTitle>
            </CardHeader>
            <CardContent className="pt-6">
              <ConfigForm
                config={config}
                onGuardar={handleGuardar}
              />
            </CardContent>
          </Card>
        </div>

        <div className="lg:col-span-1">
          <ConnectionStatus
            config={config}
            testResult={testResult}
            onTest={handleTestConexion}
          />
        </div>
      </div>
    </div>
  )
}
